<template>
    <vue-good-table
        mode="remote"
        :total-rows="totalRows"
        :is-loading="isLoading"
        :pagination-options="{
            enabled: true,
            perPage: serverParams.perPage,
            perPageDropdown: [10, 50, 100],
            dropdownAllowAll: false,
            setCurrentPage: serverParams.page,
        }"
        :rows="rows"
        :columns="columns"
        @page-change="onPageChange"
        @sort-change="onSortChange"
        @column-filter="onColumnFilter"
        @per-page-change="onPerPageChange"
        @form-submit-success="loadRows"
    >
        <template #table-row="props">
            <span v-if="(props.column.label === 'Action')">
                <action-button
                    method="delete"
                    :endpoint="`/admin/api/series-translations/${props.row.id}`"
                >
                    Delete

                </action-button>
            </span>
            <span v-else>
                {{ props.formattedRow[props.column.field] }}
            </span>
        </template>
    </vue-good-table>
</template>

<script>
import { EventBus } from "../EventBus.js";
import Table from "../mixins/Table.js";
import ActionButton from "./ActionButton.vue";

export default {
  components: {
    ActionButton,
  },

  mixins: [
    Table,
  ],

  data() {
    return {
      columns: [
        {
          label: "ID",
          field: "id",
          filterOptions: {
            enabled: true,
            filterFn: () => true,
          },
        },
        {
          label: "Type",
          field: "type",
          formatFn: (str) => str.charAt(0).toUpperCase() + str.slice(1),
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Content",
          field: "content",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Language",
          field: "language.name",
          sortable: false,
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Action",
          field: "btn",
          sortable: false,
          filterOptions: {
            enabled: false,
          },
        },
      ],
      rows: [],
      totalRows: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "id",
          type: "asc",
        },
        page: 1,
        perPage: 10,
      },
    };
  },

  mounted() {
    EventBus.$on("actioned", (data) => {
      this.loadRows();
    });
  },
};
</script>
